<div class="w-100 h-100">
    <div class="row row-table">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-header">
                    <div class="form-row justify-content-between align-items-center w-100">
                        <div class="col-auto">
                            <label class="card_header_text">
                                {{$t('shared.providerRequests')}} ({{providerRequestsCount}})
                            </label>
                        </div>
                        <div class="col-auto">
                            <button :disabled="!canBulkActionPendingOnly" class="btn btn-primary btn-action" @click="showapproveDialog()">{{$t('dashboardPage.Approve')}}</button>
                            <button :disabled="!canBulkActionPendingOnly" class="btn btn-primary btn-action" @click="showRejectDialog()">{{$t('dashboardPage.reject')}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="input-group mb-3">
                                <input class="form-control border-right-0 border-left"
                                       v-model="filterModel.name"
                                       type="text" :placeholder="$t('shared.name')"
                                       @input="onInputFilterDebounced" />
                                <div class="input-group-append">
                                    <span class="input-group-text right gray">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="input-group mb-3">
                                <input class="form-control border-right-0 border-left"
                                       v-model="filterModel.enterpriseUnifiedNumber"
                                       type="text" :placeholder="$t('shared.enterpriseUnifiedNumber')"
                                       @input="onInputFilterDebounced" />
                                <div class="input-group-append">
                                    <span class="input-group-text right gray">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="input-group mb-3">
                                <input class="form-control border-right-0 border-left"
                                       v-model="filterModel.accreditationNumber"
                                       type="text" :placeholder="$t('shared.accreditationNumber')"
                                       @input="onInputFilterDebounced" />
                                <div class="input-group-append">
                                    <span class="input-group-text right gray">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="input-group mb-3">
                                <input class="form-control border-right-0 border-left"
                                       v-model="filterModel.taxNumber"
                                       type="text" :placeholder="$t('shared.taxNumber')"
                                       @input="onInputFilterDebounced" />
                                <div class="input-group-append">
                                    <span class="input-group-text right gray">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="input-group mb-3">
                                <v-menu v-model="createdDateFromMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        lazy
                                        full-width
                                        min-width="290px"
                                        offset-y attach>
                                    <template v-slot:activator="{ on }">
                                        <div class="input-group">
                                            <input class="form-control border-right-0 border-left"
                                                   v-model="filterModel.createdDateFrom"
                                                   :placeholder="$t('shared.createdDateFrom')"
                                                   readonly
                                                   v-on="on" type="text" />
                                            <div class="input-group-append">
                                                <span class="input-group-text right gray">
                                                    <i class="far fa-calendar-alt"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </template>
                                    <v-date-picker v-model="filterModel.createdDateFrom" no-title scrollable
                                                   @input="onDateChange('from')">
                                    </v-date-picker>
                                </v-menu>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="input-group mb-3">
                                <v-menu v-model="createdDateToMenu"
                                        :close-on-content-click="false"
                                        lazy
                                        full-width
                                        :nudge-right="40"
                                        min-width="290px"
                                        transition="scale-transition" offset-y attach>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div class="input-group">
                                            <input class="form-control border-right-0 border-left"
                                                   v-model="filterModel.createdDateTo"
                                                   :placeholder="$t('shared.createdDateTo')"
                                                   readonly v-bind="attrs" v-on="on" type="text" />
                                            <div class="input-group-append">
                                                <span class="input-group-text right gray">
                                                    <i class="far fa-calendar-alt"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </template>
                                    <v-date-picker v-model="filterModel.createdDateTo" no-title scrollable
                                                   @input="onDateChange('to')">
                                    </v-date-picker>
                                </v-menu>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <v-select
                                    style="width: 100%;"
                                    v-model="filterModel.requestStatus"
                                    :items="requestStatusList"
                                    item-text="name"
                                    item-value="id"
                                    :placeholder="$t('shared.requestStatus')"
                                    solo
                                    dense
                                    clearable
                                    attach
                                    @change="onRequestStatusFilterChange">
                            </v-select>
                        </div>
                        <div class="col-md-1 mt-1">
                            <button @click="reset" class="btn btn-primary btn-action">{{$t('shared.reset')}}</button>
                        </div>
                    </div>
                    <template>
                        <v-data-table v-model="selected"
                                      :headers="headers"
                                      :items="providerRequests"
                                      :total-items="providerRequestsCount"
                                      select-all
                                      item-key="id"
                                      :pagination.sync="pagination"
                                      @update:pagination="updatePaginate"
                                      :rows-per-page-text="$t('shared.rowsPerPage')"
                                      :rows-per-page-items='[10, 25, 50, 100]'
                                      class="elevation-1 table-striped">
                            <template v-slot:headers="props">
                                <tr>
                                    <th>
                                        <v-checkbox :input-value="props.all"
                                                    :indeterminate="props.indeterminate"
                                                    primary
                                                    hide-details
                                                    @click.stop="selectAll"></v-checkbox>
                                    </th>
                                    <th class="text-center" v-for="header in props.headers"
                                        :key="header.text"
                                        :class="['column text-center', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', (header.value === pagination.sortBy) && isSorted && header.sortable ? 'active' : '']"
                                        @click="header.sortable ? changeSort(header.value) : null">
                                        <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
                                        {{ header.text }}
                                    </th>
                                </tr>
                            </template>
                            <template v-slot:items="props">
                                <tr>
                                    <td>
                                        <v-checkbox v-model="props.selected"
                                                    @change="select($event, props.item.id)"
                                                    primary
                                                    hide-details></v-checkbox>
                                    </td>
                                    <td class="text-center">{{ props.item.name }}</td>
                                    <td class="text-center">{{ props.item.enterpriseUnifiedNumber }}</td>
                                    <td class="text-center">{{ props.item.accreditationNumber }}</td>
                                    <td class="text-center">{{ props.item.taxNumber }}</td>
                                    <td class="text-center">{{ formatCreatedDateOnly(props.item.createdDate) || '—' }}</td>
                                    <td class="text-center">
                                        <div :class="'status-' + props.item.providerRequestStatus">{{ GetProviderRequestStatus(props.item.providerRequestStatus)}}</div>
                                    </td>
                                    <td class="text-center btn_menu">
                                        <template>
                                            <v-menu offset-y open-on-hover>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn color="btn-primary"
                                                           v-on="on">
                                                        <div>{{$t('shared.actions')}}</div>
                                                        <i class="fas fa-chevron-down pl-4" style="vertical-align: sub;"></i>
                                                    </v-btn>
                                                </template>
                                                <v-list>
                                                    <v-list-tile v-if="props.item.providerRequestStatus == 1" @click="showapproveDialog(props.item.id)">
                                                        <v-list-tile-title class="white">{{$t('dashboardPage.Approve')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile v-if="props.item.providerRequestStatus == 1" @click="showRejectDialog(props.item.id)">
                                                        <v-list-tile-title class="white">{{$t('dashboardPage.reject')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile @click="Details(props.item.id)">
                                                        <v-list-tile-title class="white">{{$t('dashboardPage.details')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                </v-list>
                                            </v-menu>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </template>
                </div>
            </div>
        </div>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="approveDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.approveInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideapproveDialog"></i>
                    </div>
                </v-card-title>

                <v-card-text class="text-center">
                    <img :src="require('../img/folder.svg')" />
                    <p class="mt-3">
                        {{ bulkApproveMode ? $t('shared.approveProviderRequestsBulk') : $t('shared.approveProviderRequestInputText') }}
                    </p>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideapproveDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="approve">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <v-dialog v-model="rejectdialog" persistent width="554">
        <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
                {{$t('dashboardPage.reject')}}
                <div class="close__dialog">
                    <i class="fas fa-times" @click="hideRejectDialog"></i>
                </div>
            </v-card-title>
            <v-card-text>
                <div class="text-center">
                    <img :src="require('../img/folder.svg')" />
                    <p class="mt-3">
                        {{ bulkRejectMode ? $t('shared.rejectProviderRequestsBulk') : $t('shared.rejectProviderRequestInputText') }}
                    </p>
                </div>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>{{$t('dashboardPage.rejectreason')}}</label>
                            <input class="form-control" v-model="rejectResone" type="text" />
                        </div>
                    </div>
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <div class="form-row justify-content-end align-items-center">
                    <div class="col-auto mx-3">
                        <a class="link_danger" @click="hideRejectDialog">
                            {{$t('shared.cancel')}}
                        </a>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-danger px-5 py-2" :disabled="!rejectReasonIsValid" @click="reject">{{$t('shared.Ok')}}</button>
                    </div>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
